import { render } from "./post-metfone-service.vue?vue&type=template&id=61eb1656"
import script from "./post-metfone-service.vue?vue&type=script&lang=js"
export * from "./post-metfone-service.vue?vue&type=script&lang=js"

import "./post-metfone-service.vue?vue&type=style&index=0&id=61eb1656&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__